module.exports = __webpack_public_path__ + "static/media/ubeda.444c1f20.jpg";